import React from 'react'
import DashboardContent from '../DashboardContent'
import GroupChatList from '@/modules/GroupChat/Index'
import ManageSubAdmin from '@/modules/ManageSubAdmin/ManageSubAdmin'
import MobileContactForm from '@/modules/MobileContactForm/Index'
import RegisteredBabysitter from '@/modules/RegisteredBabysitter'
import RegisteredConsumer from '@/modules/RegisteredConsumer'
import SettingComponent from '@/modules/SettingComponent'
import WebContactForm from '@/modules/WebContactForm/Index'
import { ReactComponent as ContactFormIcon } from '@/assets/Sidebar/contact-form.svg'
import { ReactComponent as DashboardIcon } from '@/assets/Sidebar/dashboard.svg'
import { ReactComponent as GroupChatIcon } from '@/assets/Sidebar/group-chat.svg'
import { ReactComponent as ManageSubAdminIcon } from '@/assets/Sidebar/manage-sub-admin.svg'
import { ReactComponent as RandomCheckInIcon } from '@/assets/Sidebar/random-check-in.svg'
import { ReactComponent as SettingIcon } from '@/assets/Sidebar/setting.svg'
import { ReactComponent as UserGroupIcon } from '@/assets/Sidebar/user-group.svg'
import RandomCheckIns from '@/modules/RandomCheckIns'

const sidebarMenu = [
  {
    name: 'Dashboard',
    tabName: 'dashboard',
    icon: DashboardIcon,
    component: <DashboardContent />,
    iconFill: true,
  },
  {
    name: 'Manage Sub-Admins',
    tabName: 'sub-admin',
    icon: ManageSubAdminIcon,
    component: <ManageSubAdmin />,
    iconFill: true,
  },
  {
    name: 'Registered Supervisor',
    tabName: 'reg-supervisor',
    icon: UserGroupIcon,
    component: <RegisteredBabysitter />,
    iconFill: false,
  },
  {
    name: 'Registered Participant',
    tabName: 'reg-participant',
    icon: UserGroupIcon,
    component: <RegisteredConsumer />,
    iconFill: false,
  },
  {
    name: 'Random Check-ins',
    tabName: 'random-check-ins',
    icon: RandomCheckInIcon,
    component: <RandomCheckIns />,
    iconFill: true,
  },
  {
    name: 'Group Chat',
    tabName: 'group-chat',
    icon: GroupChatIcon,
    component: <GroupChatList />,
    iconFill: false,
  },
  {
    name: 'Mobile Contact Form',
    tabName: 'mobile-contact-form',
    icon: ContactFormIcon,
    component: <MobileContactForm />,
    iconFill: false,
  },
  {
    name: 'Web Contact Form',
    tabName: 'web-contact-form',
    icon: ContactFormIcon,
    component: <WebContactForm />,
    iconFill: false,
  },
  {
    name: 'Settings',
    tabName: 'setting',
    icon: SettingIcon,
    component: <SettingComponent />,
    iconFill: true,
  },
]

export default sidebarMenu
